function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.727 4.243l-8.485 8.485m8.485 0L4.242 4.243",
  stroke: "#fff",
  strokeWidth: 1.5
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNyAxNyI+CiAgPHBhdGggZD0iTTEyLjcyNyA0LjI0M2wtOC40ODUgOC40ODVNMTIuNzI3IDEyLjcyOEw0LjI0MiA0LjI0MyIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K";
export { SvgClose as ReactComponent };